module.exports = __webpack_public_path__ + "static/img/img-10.7b3e5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-10.png
// module id = 6gY8
// module chunks = 1